import { GetRequestOptions } from "./grunt";
const StatusOk = { status: 200 };



const insertSpecifikacijaFromPopis=async(_rggid,_datum,_kamionregbr)=>{
    //"/migracija/migracijatip/dokumenttip"
    const pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/popis/${_rggid}?datum=${_datum}&kamionbr=${_kamionregbr}`;
    try {
        const r = await fetch(pth, GetRequestOptions("POST"));
        const res = await r.json();
        if (r.status===200) {
            StatusOk.res=res;  
            return StatusOk;  
        } else {
            return res;
        }//StatusOk.res=res.Popis;  
        
    } catch (ex) {
        return { code: ex.code, message: "Greška kod kreiranja specifikacije. " + ex.message, status: ex.status, name: ex.name };
    }
}

const addSpecifikacija=async(_kamionbr,_migracijadatum,_migracijaijr,_migrdoktipid,_dokumentbroj,_migracposid,_jibg,_tezina,_goveda,_organizatorid)=>{
    const pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/`;
    const _data={
        kamion_br:_kamionbr,
        migracija_datum:_migracijadatum,
        migracija_ijr:_migracijaijr,
        migrdok_tip_id:_migrdoktipid,
        dokument_broj:_dokumentbroj,
        migracija_posjednik_id:_migracposid,
        jibg:_jibg,
        tezina:_tezina,
        organizator_subjekt_id:_organizatorid,
        goveda:[]
    }
    for (const _g of _goveda) {
        _data.goveda.push({popis_govedo_id:_g.popis_govedo_id===undefined?-1:_g.popis_govedo_id,govedo_migracija_id:_g.govedo_migracija_id});
    }
    //
    try {
        let _reqopt = GetRequestOptions("POST");
        _reqopt.body=JSON.stringify(_data);
        const r = await fetch(pth, _reqopt);
        const res = await r.json();
        if (r.status===200) {
            StatusOk.res=res;  
            return StatusOk;  
        } else {
            return res;
        }
        
    } catch (ex) {
        return { code: ex.code, message: "Greška kod unosa podataka. " + ex.message, status: ex.status, name: ex.name };
    }
}

const updateSpecifikacija=async(_specifikacijaid,_kamionbr,_migracijadatum,_migracijaijr,_migrdoktipid,_dokumentbroj,_migracposid,_jibg,_tezina,_goveda,_organizatorid)=>{
    const pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/${_specifikacijaid}`;
    const _data={
        kamion_br:_kamionbr,
        migracija_datum:_migracijadatum,
        migracija_ijr:_migracijaijr,
        migrdok_tip_id:_migrdoktipid,
        dokument_broj:_dokumentbroj,
        migracija_posjednik_id:_migracposid,
        jibg:_jibg,
        tezina:_tezina,
        organizator_subjekt_id:_organizatorid,
        goveda:[]
    }
    for (const _g of _goveda) {
        _data.goveda.push({popis_govedo_id:_g.popis_govedo_id===undefined?-1:_g.popis_govedo_id,govedo_migracija_id:_g.govedo_migracija_id});
    }
    //
    try {
        let _reqopt = GetRequestOptions("PUT");
        _reqopt.body=JSON.stringify(_data);
        const r = await fetch(pth, _reqopt);
        const res = await r.json();
        if (r.status===200) {
            StatusOk.res=res;  
            return StatusOk;  
        } else {
            return res;
        }
        
    } catch (ex) {
        return { code: ex.code, message: "Greška kod ažuriranja podataka. " + ex.message, status: ex.status, name: ex.name };
    }
}

const getSpecifikacije=async(_rggid,_datum,_kamionregbr)=>{
    //"/migracija/migracijatip/dokumenttip"
    const pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/`;
    try {
        const r = await fetch(pth, GetRequestOptions("GET"));
        const res = await r.json();
        if (r.status===200) {
            StatusOk.res=res;  
            return StatusOk;  
        } else {
            return res;
        }
        
    } catch (ex) {
        return { code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name };
    }
}

const getSpecifikacija=async(_specid)=>{
    //"/migracija/migracijatip/dokumenttip"
    const pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/${_specid}`;
    try {
        const r = await fetch(pth, GetRequestOptions("GET"));
        const res = await r.json();
        if (r.status===200) {
            StatusOk.res=res;  
            return StatusOk;  
        } else {
            return res;
        }
        
    } catch (ex) {
        return { code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name };
    }
}

const getOrganizatori=async()=>{
    //"/migracija/migracijatip/dokumenttip"
    const pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/organizator`;
    try {
        const r = await fetch(pth, GetRequestOptions("GET"));
        const res = await r.json();
        if (r.status===200) {
            StatusOk.res=res;  
            return StatusOk;  
        } else {
            return res;
        }
        
    } catch (ex) {
        return { code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name };
    }
}

const delSpecifikacija=async(_specid)=>{
    //"/migracija/migracijatip/dokumenttip"
    const pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/${_specid}`;
    try {
        const r = await fetch(pth, GetRequestOptions("DELETE"));
        const res = await r.json();
        if (r.status===200) {
            StatusOk.res=res;  
            return StatusOk;  
        } else {
            return res;
        }
        
    } catch (ex) {
        return { code: ex.code, message: "Greška kod brisanja podataka. " + ex.message, status: ex.status, name: ex.name };
    }
}


const getPojedinacnaGrlaForSpecifikacija=async(_knjigaid)=>{
   ///goveda/:knjigaid
    const pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/goveda/${_knjigaid.toString()}`;
    try {
        const r = await fetch(pth, GetRequestOptions("GET"));
        const res = await r.json();
        if (r.status===200) {
            StatusOk.res=res.Popis;  
            return StatusOk;  
        } else {
            return res;
        }
        
    } catch (ex) {
        return { code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name };
    }
}

const createMigracijaFromSpecifikacija=async(_specid)=>{
    /*"/migracija/:specifikacijaid" */
    const pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/migracija/${_specid}`;
    try {
        const r = await fetch(pth, GetRequestOptions("POST"));
        const res = await r.json();
        if (r.status===200) {
            
            return StatusOk;  
        } else {
            return res.message;
        }
        
    } catch (ex) {
        return { code: ex.code, message: "Greška kod kreiranja migracije. " + ex.message, status: ex.status, name: ex.name };
    }
}

const getOdabranaGovedaZaSpecifikaciju=async(_govedaid=null,_specid=null)=>{
    ///goveda/:knjigaid
    let pth="";
    if (_govedaid!==null && _specid===null) {
         pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/govedaforspecifikacija/${_govedaid.toString().replaceAll(',','_')}`;   
    } else {
        pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/govedaforspecifikacija/specifikacija/${_specid}`;   
    }
     
     try {
         const r = await fetch(pth, GetRequestOptions("GET"));
         const res = await r.json();
         if (r.status===200) {
             StatusOk.res=res.Popis;  
             return StatusOk;  
         } else {
             return res;
         }
         
     } catch (ex) {
         return { code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name };
     }
 }

 const getPopisGovedoNaSpecifikacijiXlsx=async(_specid)=>{
    try {
        const _pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/goveda/specifikacija/xlsx/${_specid}`;   
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.arrayBuffer();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getSpecifikacijaUsnihMarkicaPdf=async(_specid)=>{
    /*/ispis/specusnemarkice/:specid */
    try{
        const _reqopt=GetRequestOptions("GET");
        const _pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/ispis/specusnemarkice/${_specid}`;   
        const r = await fetch(_pth, _reqopt);
        const res=await r.blob();

        if (r.status===200) {
        StatusOk.res=res;
        return StatusOk;
        } else {
            throw new Error(r.statusText);               
        }
        
  } catch (ex) {
    return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
  }
}
const getVetSpecifikacijaXlsx=async(_specid)=>{
    /*/ispis/specusnemarkice/:specid */
    try{
        const _reqopt=GetRequestOptions("GET");
        const _pth=process.env.REACT_APP_GRUNT_API +`/specifikacija/ispis/specveterinarskaxls/${_specid}`;   
        const r = await fetch(_pth, _reqopt);
        //const res=await r.blob();
        const res=await r.arrayBuffer();

        if (r.status===200) {
        StatusOk.res=res;
        return StatusOk;
        } else {
            throw new Error(r.statusText);               
        }
        
  } catch (ex) {
    return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
  }
}
export {insertSpecifikacijaFromPopis,getSpecifikacije,getPojedinacnaGrlaForSpecifikacija,updateSpecifikacija,
    getOdabranaGovedaZaSpecifikaciju,addSpecifikacija,delSpecifikacija,getSpecifikacija,createMigracijaFromSpecifikacija,
    getPopisGovedoNaSpecifikacijiXlsx,getSpecifikacijaUsnihMarkicaPdf,getOrganizatori,getVetSpecifikacijaXlsx};